import { GuestProfile, MatchField } from '@mews-commander/guest-profile';
import { createHandler } from '@mews/std';
import { Divider, Grid, Stack } from '@optimus-web/core';
import { matchAndMergeTestIds } from '../../../../../constants';
import { FieldHeading } from './FieldHeading';
import { FieldValue } from './FieldValue';

const getKeyByMatchField = createHandler<
    MatchField,
    keyof Pick<
        GuestProfile,
        'birthDate' | 'email' | 'firstName' | 'lastName' | 'paymentCard' | 'phone' | 'secondLastName'
    >
>({
    [MatchField.BirthDate]: 'birthDate',
    [MatchField.Email]: 'email',
    [MatchField.FirstName]: 'firstName',
    [MatchField.LastName]: 'lastName',
    [MatchField.PaymentCard]: 'paymentCard',
    [MatchField.Phone]: 'phone',
    [MatchField.SecondLastName]: 'secondLastName',
});

export const FieldsRow = ({
    matchingFields,
    isLast,
    values,
}: {
    matchingFields: Array<MatchField>;
    isLast: boolean;
    values: GuestProfile;
}) => (
    <Grid templateColumns={`repeat(${matchingFields.length}, 1fr)`} columnGap="300">
        {matchingFields.map((fieldName) => {
            const valueKey = getKeyByMatchField(fieldName);

            return (
                <Stack
                    data-test-id={`${matchAndMergeTestIds.matchingFields}-${fieldName}`}
                    vertical
                    spacing="200"
                    alignment="center"
                >
                    <Stack vertical spacing="100" alignment="center" itemAlignment="center" fill>
                        <FieldHeading property={fieldName} />
                        <FieldValue type={fieldName} value={values[valueKey]} />
                    </Stack>
                    {!isLast ? <Divider /> : null}
                </Stack>
            );
        })}
    </Grid>
);
